import { render } from "./ActivitiesPriorityIconButton.vue?vue&type=template&id=0a105bfd&scoped=true"
import script from "./ActivitiesPriorityIconButton.vue?vue&type=script&lang=js"
export * from "./ActivitiesPriorityIconButton.vue?vue&type=script&lang=js"

import "./ActivitiesPriorityIconButton.vue?vue&type=style&index=0&id=0a105bfd&lang=scss&scoped=true"
import "./ActivitiesPriorityIconButton.vue?vue&type=style&index=1&id=0a105bfd&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a105bfd"]])

export default __exports__